import React from 'react';

import { BarChart, ChartContainer } from '@/components/organisms/Aggregates';
import { CmCard, CmHeading } from '@/components/uiParts';
import { ChartDatum } from '@/domain/models/Chart';
import { createBarDatumFromChartDatum } from '@/domain/models/Chart';
import { Days } from '@/domain/models/Day';
import { SalesByDayOfWeekItem } from '@/domain/models/SalesReport';

interface Props {
  salesWeek: SalesByDayOfWeekItem[];
}

const projectToTotalPriceDatumByDayOfTheWeek = (
  salesWeek: SalesByDayOfWeekItem[]
): ChartDatum | null => {
  if (salesWeek.length <= 0) return null;

  // Create a map from the provided salesWeek data
  const salesMap = new Map<string, number>();
  salesWeek.forEach(({ day_of_week, total_sales }) => {
    salesMap.set(day_of_week.toLowerCase().slice(0, 3), total_sales);
  });

  // Map each day to its total sales or default to 0 if not present
  const totalPriceDatum: ChartDatum = {
    id: 'totalPrice',
    data: Days.map((day) => {
      const x = day;
      const y = salesMap.get(day) || 0;
      return { x, y };
    }),
  };

  return totalPriceDatum;
};

export const SalesByDayOfTheWeek: React.FC<Props> = ({ salesWeek }) => {
  const totalPriceData = projectToTotalPriceDatumByDayOfTheWeek(salesWeek);
  const barData = totalPriceData
    ? createBarDatumFromChartDatum(totalPriceData)
    : [];

  return (
    <CmCard>
      <CmHeading as="h2">曜日ごと売上</CmHeading>
      <ChartContainer mt={5} height="250px" width="100%">
        <BarChart data={barData} axisBottomFormatter={(d) => d.toString()} />
      </ChartContainer>
    </CmCard>
  );
};
